<template>
  <div>
    <WidgetTextHeroSection
      :register-href="registerHref"
      :value="courseFlyerWidget.widget_text_hero_section"
      class="mb-10"
    />

    <WidgetFiveDifferentiatorsSection
      :value="fiveDifferentiatorsSection"
      class="mb-6 px-md-16"
    />

    <WidgetPersonSection
      v-if="trainerPerson"
      :person="trainerPerson"
      class="mb-6 px-md-16"
    />

    <DividerSection class="mb-6" />

    <WidgetDealsSection :value="dealsSection" class="mb-6 px-md-16" />

    <WidgetCourseOverviewSection
      :course="course"
      :register-href="registerHref"
      :value="courseFlyerWidget.widget_course_overview_section"
      class="mb-6"
    />

    <WidgetOccasionsSection
      :filters-value="{ what: product.code }"
      :full-schedule-href="`/training/schedule?what=${product.code}`"
      :value="courseFlyerWidget.widget_occasions_section"
      class="mb-6"
    />

    <HomeDifferentiatorsSection
      :value="courseFlyerWidget.home_differentiators_section"
      internal-player
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { onMounted, ref } from 'vue'
import { usePageContext } from '#root/renderer/usePageContext'
import { useProvideTrainerPersonsStore } from '#root/lib/useTrainerPersonsStore'
import { useOccasionsStore } from '#root/lib/useOccasionsStore'
import { useOccasionHrefs } from '#root/lib/useOccasionHrefs'

const { canonicalPaths } = usePageContext()
const { items: occasionItems, uniqueIndexes } = useOccasionsStore()

const props = defineProps({
  trainers: {
    required: true,
    type: Array
  },
  course: {
    required: true,
    type: Object
  },
  courseFlyerWidget: {
    required: true,
    type: Object
  },
  product: {
    default: undefined,
    type: Object
  }
})

useProvideTrainerPersonsStore(props.trainers)

const dealsSection = computed(() => {
  return Object.assign(
    {},
    props.courseFlyerWidget.widget_deals_section,
    props.course.widget_deals_section
  )
})
const fiveDifferentiatorsSection = computed(() => {
  return Object.assign(
    {},
    props.courseFlyerWidget.widget_five_differentiators_section,
    props.course.widget_five_differentiators_section
  )
})
const occasion = computed(() => {
  if (occasionItems.value && uniqueIndexes.value) {
    let ind

    if (occasionSKU.value) {
      ind =
        uniqueIndexes.value.product_occasion_sku &&
        uniqueIndexes.value.product_occasion_sku[
          occasionSKU.value.toUpperCase()
        ]
    } else if (eventId.value) {
      ind =
        uniqueIndexes.value.eb_event_id &&
        uniqueIndexes.value.eb_event_id[eventId.value]
    }

    if (typeof ind === 'number') {
      return occasionItems.value[ind]
    }
  }

  return null
})
const trainerPerson = computed(() => {
  if (occasion.value?.product_variant?.person) {
    const personCode = occasion.value?.product_variant?.person.code

    const person = props.trainers.find(({ code }) => code === personCode)
    if (person) return person
  }

  return null
})

const eventId = ref(null)
const occasionSKU = ref(null)
const { registerHref } = useOccasionHrefs(occasion, canonicalPaths)

onMounted(async () => {
  const url = new URL(window.location.href)
  const eid = url.searchParams.get('eid')
  const sku = url.searchParams.get('sku')

  if (eid) eventId.value = eid
  if (sku) occasionSKU.value = sku
})
</script>
